import { useParams } from 'react-router-dom';
import { Navigate, Route, Routes } from 'react-router-dom';
import ScreenBottom from './bottom';
import ScreenGraphic from './graphic';
import ScreenHeader from './header';
import './index.less';
import { useEffect, useState, useRef } from 'react';


interface IProps {

}

export default function Layout(props: IProps) {

    const { projectUuid, monixProjectId } = useParams();

    useEffect(() => {
        // todo 两个uuid为空时的处理
    }, [projectUuid, monixProjectId])

    return (
        <div className='screen-layout-container'>
            <Routes>
                <Route
                    path='monix/:monixProjectId/bim/:bimProjectId/models/:bimModelUuid'
                    element={
                        <>
                            <ScreenHeader />
                            <ScreenGraphic />
                            <ScreenBottom />
                        </>
                    }
                />
                <Route path="*" element={<Navigate to="monix/67/bim/0a366432-d40b-4477-9ece-f56a9ea04152/models/3a990dbf-66db-423a-bec7-0f7ad97754ac" />} />

            </Routes>

        </div>
    )
}